import {Injectable} from '@angular/core';
import {environment} from '@app/environments/environment';
import {HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import {JwtInterceptor} from '@auth0/angular-jwt';

@Injectable()
export class InterceptorService extends JwtInterceptor {
  headerName = 'Authorization';
  authScheme = 'Bearer ';

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const anotherApi = req.url.match(/https?:\/\//ig);
    let request: HttpRequest<any>;
    if (!anotherApi) {
      request = req.clone({
        url: environment.apiUrl + req.url
      });
    } else {
      request = req.clone();
    }

    const token: any = this.tokenGetter();
    if (token instanceof Promise) {
      return Observable.fromPromise(token).mergeMap((asyncToken: string) => {
        return this.handleInterception(asyncToken, request, next);
      });
    } else {
      return this.handleInterception(token, request, next);
    }
  }

  handleInterception(token: string, request: HttpRequest<any>, next: HttpHandler) {
    let tokenIsExpired: boolean;

    if (!token && this.throwNoTokenError) {
      throw new Error('Could not get token from tokenGetter function.');
    }

    if (this.skipWhenExpired) {
      tokenIsExpired = token ? this.jwtHelper.isTokenExpired(token) : true;
    }

    if (token && tokenIsExpired && this.skipWhenExpired) {
      request = request.clone();
    } else if (token && this.isWhitelistedDomain(request)) {
      request = request.clone({
        setHeaders: {
          [this.headerName]: `${this.authScheme}${token}`
        }
      });
    }
    return next.handle(request);

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/interceptor.service.ts